<template>
  <v-card flat>
    <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>

    <v-card-title>BYT LÖSENORD</v-card-title>
    <v-card-actions class="justify-end">
      <v-btn class="pa-0" color="secondary" @click="suggestPassword">GENERERA ETT SÄKERT LÖSENORD</v-btn>
    </v-card-actions>
    <div class="mt-8">
      <v-form ref="form">
        <v-text-field
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          outlined
          label="Nytt lösenord"
          v-model="password"
          :rules="[rules.required, rules.pwdLength]"
          @click:append="showPassword = !showPassword"
        />
        <v-text-field
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          outlined
          label="Bekräfta nytt lösenord"
          v-model="passwordConfirmation"
          :rules="[rules.required, rules.pwdLength, rules.pwdMatch(password, passwordConfirmation)]"
          @click:append="showPassword = !showPassword"
          :error-messages="error"
          @input="clearErrorMessages"
        />
        <p>
          Lösenordet måste vara minst 8 tecken och bestå av siffror, små och stora bokstäver samt minst ett
          specialtecken (-_@!#€%&amp;()=?*~^+°§).
        </p>
        <v-card-actions class="justify-end">
          <v-btn class="mt-4" color="secondary" @click="$emit('close')"><v-icon>$sl-cancel</v-icon> AVBRYT </v-btn>
          <v-btn class="mt-4" @click="resetPassword"><v-icon>$sl-check-circle</v-icon> SPARA</v-btn>
        </v-card-actions>
      </v-form>
    </div>
  </v-card>
</template>

<script>
import {mapActions} from 'vuex'
import generator from 'generate-password'
import DatePicker from '@/components/common/DatePicker'
import {Regions, RulesMixin, UserRules} from '@/components/mixins'
import API from '@/services/api'

export default {
  name: 'PersonChangePasswordModal',
  mixins: [Regions, RulesMixin, UserRules],
  components: {
    DatePicker
  },

  data: () => ({
    password: '',
    passwordConfirmation: '',
    showPassword: false,
    error: '',
    suggestedPassword: ''
  }),

  props: {
    person: {}
  },

  computed: {},

  methods: {
    ...mapActions('person', ['setSelectedPerson']),
    resetPassword() {
      this.error = ''
      const valid = this.$refs.form.validate()
      if (!valid) return

      const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-8])(?=.*[\(\)\,\;\/\=\[\]\"\:{}!@#$%^&*.?\+\-`~<>|_])(?=.{8,})/
      if (!new RegExp(strongRegex).test(this.password)) {
        this.error = 'Lösenordet är för svagt'
        return
      }

      API.changePersonPassword({
        data: {id: this.person.id, password: this.password}
      })
        .then(({data}) => {
          this.$refs.form.reset()
          this.$events.fire('showInfo', 'Personlösenordet uppdateras')
          this.$emit('close', data)
        })
        .catch(() => {
          this.$events.fire('showInfo', 'Fel. Personlösenordet uppdateras inte')
        })
    },
    suggestPassword() {
      const newPassword = generator.generate({
        length: 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true
      })
      this.showPassword = true
      this.password = newPassword
      this.passwordConfirmation = newPassword
    },
    copySuggested() {
      const textToCopy = this.$refs.textToCopy.$el.querySelector('input')
      textToCopy.select()
      document.execCommand('copy')
    },
    clearErrorMessages() {
      this.error = ''
    }
  }
}
</script>

<style></style>
